import { render, staticRenderFns } from "./PersonBatchProfileDownload.vue?vue&type=template&id=4f5f145e&scoped=true&"
import script from "./PersonBatchProfileDownload.vue?vue&type=script&lang=js&"
export * from "./PersonBatchProfileDownload.vue?vue&type=script&lang=js&"
import style0 from "./PersonBatchProfileDownload.vue?vue&type=style&index=0&id=4f5f145e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f145e",
  null
  
)

export default component.exports